import { UserPermissions } from '../../../../../enums'; 

export const answerRoutes = [
    {
        path: '',
        name: 'AssessmentAnswers',
        component: () => import('../views/Index.vue'),
        meta: {
            breadcrumb: [{ label: 'Assessments' }],
            requiresAuth: true,
            permission: [UserPermissions.READ_ASSESSMENT_FORM],
        },
    },
    {
        path: 'document-preview/:assessmentCode/:formId',
        name: 'DocumentPreview',
        component: () => import('@/pages/assessments/DocumentPreview.vue'),
        meta: {
            breadcrumb: [{ parent: 'Assessments', label: 'Document Preview' }],
            requiresAuth: true,
            permission: [UserPermissions.READ_ASSESSMENT_FORM],
        },
    },
    {
        path: 'unassessed',
        name: 'UnassessedUsers',
        component: () => import('../views/UnassessedUsers.vue'),
        meta: {
            breadcrumb: [{ parent: 'Assessments', label: 'Unassessed Users' }],
            requiresAuth: true,
            permission: [UserPermissions.READ_ASSESSMENT_FORM],
        },
    },
];

export const userAssessmentRoutes = [
    {
        path: 'assessments',
        name: 'UserSpecificAnswersTable',
        props: true,
        component: () => import('../views/UserSpecificAnswersTable.vue'),
        meta: {
            breadcrumb: [{ parent: 'User', label: 'Assessments' }],
            requiresAuth: true,
            permission: [UserPermissions.READ_ASSESSMENT_FORM],
        },
    },
];
